<template>
    <div class="newlpr">
        <p class="back" @click="back">返回上一级</p>
        <div class="content">
            <h1 style="font-size: 18px;margin-bottom: 20px;">视点深度｜首度亮相的民事强制执行法草案亮点解析</h1>
            <div class="cont">
                <p>惩戒“老赖”：明确法律依据，加大震慑力度</p>
                <p>一边欠债不还，一边花天酒地……“老赖”现象影响司法权威、损害社会诚信，群众对此深恶痛绝。</p>
                <p>近年来，失信联合惩戒制度成为我国诚信建设一大亮点。此次提请审议的民事强制执行法草案，通过立法明确对“老赖”的惩戒措施，让其切身体会“一处失信，处处受限”。</p>
                <p>草案明确，被执行人不履行执行依据确定义务的，人民法院可以禁止其进行高消费及非生活或者经营必需的有关消费，可以限制其出境。</p>
                <p>草案还明确了纳入失信被执行人名单措施的适用条件，包括：有证据证明被执行人有履行能力而拒不履行执行依据确定的义务;以虚假诉讼、虚假仲裁、虚假公证或者以隐匿、转移、毁损财产等方法逃避履行执行依据确定的义务;违反限制消费令进行消费等行为。</p>
                <p>有上述行为之一的，人民法院可以根据情节轻重予以罚款、拘留;构成犯罪的，依法追究刑事责任。</p>
                <p>中国社会科学院法学研究所民法室主任谢鸿飞表示，随着经济社会发展，单位及自然人的财产情况日趋复杂，逃避执行的手段更加多样。制定专门的民事强制执行法，有助于解决执行实践中存在的适用法律问题，为人民法院严格规范公正文明办理执行案件提供充分法律依据，为民事主体实现权利提供更有力的法律保障。</p>
                <p>北京理工大学法学院民法典研究中心主任孟强表示，草案明确法院可以视情节轻重对失信被执行人予以罚款、拘留或者依法追究刑事责任，将进一步加强法律的震慑力，对失信被执行人形成有效约束。</p>
                <p>“被执行人之所以敢无视生效法律文书，逃避执行甚至公然对抗执行，深层原因是逃债赖债的违法成本过低、社会信用机制失灵、执行威慑机制缺失。”中国人民大学法学院教授肖建国认为，草案大幅提升背德失信者的道德、经济和法律成本，挤压被执行人的逃债空间，将对失信被执行人产生有效威慑。</p>
                <p>形成合力：明确协助义务，建立律师调查令制度</p>
                <p>东躲西藏、转移财产、虚假诉讼……现实生活中，一些“老赖”为了逃避执行花招百出。破解执行领域的人难找、物难查等问题，需要有关部门以及社会各界充分配合，形成合力。</p>
                <p>民事强制执行法草案明确，执行中，有关组织和个人应当根据人民法院的通知，协助实施调查被执行人及有关人员的财产、身份信息;查找被执行人、被拘传人、被拘留人;查封、划拨、限制消费、限制出境等事项。负有协助执行义务的有关国家机关或者其他承担社会管理职能、提供社会公共服务的组织与人民法院之间应当建立信息化网络协助执行机制。</p>
                <p>“强制执行涉及财产状况的调查、人身自由的限制等诸多方面，如果相关组织或个人不配合，不仅会让法院陷入‘单打独斗’的执行困局，还可能让当事人对司法判决产生质疑，影响司法权威。”谢鸿飞表示，明确各方面配合执行工作的法定义务，有助于实现执行信息及时共享，提高执行的效率和准确性。</p>
                <p>草案还规定，人民法院通过网络信息平台无法查询的某项财产信息，申请执行人通过委托律师客观上无法自行调取的，可以委托律师向人民法院申请调查令。</p>
                <p>肖建国表示，律师调查令本质上是一种司法领域的授权调查法律关系，有法院公权力作为后盾支持，具有一定的强制性效力。这一制度有助于减轻法院执行部门“案多人少”的工作压力，强化当事人在强制执行中的主体地位。</p>
                <p>随着经济社会发展，股权、知识产权、虚拟财产等新的财产类型不断出现。为了进一步强化被执行人报告财产义务，草案明确了报告财产令制度，规定被执行人收到法院发出的报告财产令后，应当于指定的日期亲自到场报告。</p>
                <p>孟强建议，尽快完善财产权登记制度，实现登记和查询电子化、联网化;审判机关也应充分了解执行领域相关疑难问题，让判决更具可执行性。</p>
                <p>规范执行：加强监督制约，破解执行失范</p>
                <p>实践中，有司法人员过度采取执行措施，还有的选择性执行甚至乱执行……这些执行失范问题，严重影响司法公信力。</p>
                <p>草案明确，民事强制执行应当公平、合理、适当，兼顾各方当事人和利害关系人的合法权益，不得超过实现执行目的所需的必要限度。草案同时规定，被执行人为未成年人的，人民法院不得将其纳入失信被执行人名单。</p>
                <p>“一些地方执行措施比较激进，不当限制被执行人人格权。”孟强表示，执行人员应稳妥区分无力履行和拒不履行，厘清债务人财产和他人财产等情况，把握强制执行措施的“度”。草案突出“善意文明执行”的立法理念，确保执行工作既实现公平正义，又平衡保护各方合法权益。</p>
                <p>为进一步解决消极执行、乱执行等执行失范问题，草案还规定了当事人、利害关系人可以就人民法院未实施应当实施的执行行为提出申请的制度和人民法院的自行纠正制度。</p>
                <p>“这有助于引导执行申请人积极行使权利保护自身权益，加强对法院执行工作的监督，督促法院及时正确履职。”谢鸿飞说。</p>
                <p>草案同时规定，经当事人、利害关系人申请，人民检察院认为同级或者下级人民法院的执行行为违反法律规定、应当实施执行行为而未实施或者在执行中作出的其他生效裁定、决定确有错误，需要纠正的，应当提出检察建议。</p>
                <p>肖建国建议，进一步完善强制执行救济制度，为执行参与人提供充分的救济程序。比如，对于严重消极执行行为，除了执行机构自行纠正、上级法院执行监督、检察机关监督外，还有必要赋予当事人、利害关系人申请提级管辖等权利。</p>
            </div>
            <!-- <p class="referee"><span style="line-height: 20px;">声明：以上部分内容来源于网络，如有侵犯原创版权请告知，我们将尽快删除相关内容。</span></p> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods:{
        back(){
            this.$router.go(-1);
        }
    }
}
</script>
<style lang="less" scoped>
.newlpr{
    width: 100%;
    .back{
        float: right;
    }
    .backs{
        float: right;
        font-size: 14px;
        line-height: 20px;
    }
    .content{
        width: 100%;
        margin: 0 auto;
        margin-top: 20px;
        h5{
            // font-size: 18px;
        }
        .referee{
            font-size: 14px;
            text-indent: 2em;
            span{
                background-color: rgb(239, 239, 239);
            }
        }
        .cont{
            width: 100%;
            margin-top: 25px;
            p{
                text-indent: 2em;
                line-height: 25px;
                font-size: 14px;
            }
        }
    }
}
</style>
